import { Link } from 'react-router-dom'

interface Props {
  heading?: string
  message?: string
}

export default function NotFoundPage({
  heading = 'Restaurant not found',
  message = "The page you're looking for doesn't exist.",
}: Props) {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-slate-50 text-slate-900">
      <div className="text-center px-6">
        <h1 className="text-4xl font-bold text-slate-700 mb-3">{heading}</h1>
        <p className="text-slate-500 mb-6">{message}</p>
        <Link
          to="/"
          className="text-emerald-600 underline underline-offset-2 hover:text-emerald-700"
        >
          Back to home
        </Link>
      </div>
    </main>
  )
}
